import { useT } from '@/i18n'
import { Dialog } from '@/components/ui/dialog'

function Key({ children }: { children: string }) {
  return (
    <kbd className="inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-border-default bg-surface-1 px-1 font-mono text-xs text-secondary">
      {children}
    </kbd>
  )
}

function Row({ keys, label }: { keys: string[]; label: string }) {
  return (
    <div className="flex items-center gap-3 py-1">
      <span className="flex w-28 shrink-0 gap-1">
        {keys.map((k) => (
          <Key key={k}>{k}</Key>
        ))}
      </span>
      <span className="text-base text-secondary">{label}</span>
    </div>
  )
}

/** `?` bilan ochiladi (SKILL §6 tekshiruv ro'yxati). */
export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const t = useT()
  return (
    <Dialog open={open} onClose={onClose} title={t.shortcuts.title} width="md">
      <div className="grid gap-6 sm:grid-cols-2">
        <div>
          <p className="mb-1.5 text-xs font-medium tracking-wide text-tertiary uppercase">
            {t.shortcuts.navigation}
          </p>
          <Row keys={['j', '↓']} label={t.shortcuts.nextRow} />
          <Row keys={['k', '↑']} label={t.shortcuts.prevRow} />
          <Row keys={['Enter']} label={t.shortcuts.open} />
          <Row keys={['Space']} label={t.shortcuts.detailPanel} />
          <Row keys={['g', 'h']} label={t.shortcuts.goHome} />
        </div>
        <div>
          <p className="mb-1.5 text-xs font-medium tracking-wide text-tertiary uppercase">
            {t.common.actions}
          </p>
          <Row keys={['x']} label={t.shortcuts.select} />
          <Row keys={['⇧', 'x']} label={t.shortcuts.selectRange} />
          <Row keys={['⌘', 'K']} label={t.shortcuts.globalSearch} />
          <Row keys={['/']} label={t.shortcuts.focusFilter} />
          <Row keys={['⌘', '\\']} label={t.shortcuts.toggleSidebar} />
          <Row keys={['Esc']} label={t.shortcuts.escape} />
          <Row keys={['?']} label={t.shortcuts.showShortcuts} />
        </div>
      </div>
    </Dialog>
  )
}
